import React from 'react'
import audioCuttingHooks from './hooks'
import { AdminAssessments } from 'pages'

const AudioCuttingAssessments = () => {
    const tabs = audioCuttingHooks.useTabs()

    return (
        <AdminAssessments
            tabs={tabs}
        />
    )
}

export default AudioCuttingAssessments